module.exports = __webpack_public_path__ + "static/media/delete.032499b5.svg";